import styled from "styled-components";
import PropTypes from "prop-types";

const Button = styled.div`
  border-radius: 6px;
  border: 1px solid black;
  text-align: center;
  color: white;
  background: black;
  font-size: 13px;
  letter-spacing: 0.05em;
  font-weight: 500;
  height: 30px;
  line-height: 30px;
  max-width: 160px;
  cursor: pointer;
  transition-duration: 0.25s;
  transition-timing-function: ease-in;

  &:hover {
    background: white;
    color: black;
  }
`;

const ConfirmationButton = ({ onClick }) => (
  <Button onClick={onClick}>CONFIRM</Button>
);

ConfirmationButton.propTypes = {
  onClick: PropTypes.func,
};

export default ConfirmationButton;
